document.addEventListener('DOMContentLoaded', function () {

  var SHOP_CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || (window.denstoreCurrency) || 'USD';
  var CHECKOUT_URL = window.denstoreCheckoutUrl || '/checkout';

  /* ---------- Drawers (mobile nav / search / cart) ---------- */
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-drawer-open');
      var el = document.getElementById(id);
      if (el) el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('[data-drawer]');
      if (drawer) drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ---------- Dark mode toggle ---------- */
  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var root = document.documentElement;
      var isDark = root.getAttribute('data-theme') === 'dark';
      root.setAttribute('data-theme', isDark ? 'light' : 'dark');
      try { localStorage.setItem('denstore-theme', isDark ? 'light' : 'dark'); } catch (e) {}
    });
  });

  /* ---------- FAQ / description accordion ---------- */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item, .product-info__accordion');
      var answer = item.querySelector('.faq-item__answer');
      if (!item || !answer) return;
      var willOpen = !answer.classList.contains('is-open');
      answer.classList.toggle('is-open', willOpen);
      item.classList.toggle('is-open', willOpen);
    });
  });

  /* ---------- Quantity inputs ----------
     Respects each input's own min attribute (product page stays at 1;
     cart rows allow 0, which the change handler below treats as "remove"). */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-quantity-minus]');
    var plus = e.target.closest('[data-quantity-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.quantity-input');
    var input = wrap.querySelector('[data-quantity-field]');
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = 1;
    val = plus ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = thumb.getAttribute('data-index');
      var gallery = thumb.closest('.product-gallery');
      gallery.querySelectorAll('[data-gallery-image]').forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-index') === index);
      });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---------- Product option selection ---------- */
  document.querySelectorAll('.product-option__values').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var value = e.target.closest('[data-option-value]');
      if (!value) return;
      group.querySelectorAll('.option-value').forEach(function (v) { v.classList.remove('is-selected'); });
      value.classList.add('is-selected');
      updateSelectedVariant(group.closest('.product-form'));
    });
  });

  function updateSelectedVariant(form) {
    if (!form) return;
    var selections = [];
    form.querySelectorAll('.product-option__values').forEach(function (group) {
      var selected = group.querySelector('.option-value.is-selected');
      selections.push(selected ? selected.getAttribute('data-option-value') : null);
    });
    var infoWrap = form.closest('.product-info');
    var variantData = infoWrap ? infoWrap.getAttribute('data-variants') : null;
    if (!variantData) return;
    try {
      var variants = JSON.parse(variantData);
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selections[i]; });
      });
      if (match) {
        form.querySelector('[data-selected-variant-id]').value = match.id;
        var priceEl = form.closest('.product-info').querySelector('[data-product-price]');
        if (priceEl && match.price) {
          priceEl.querySelector('.price__regular').textContent = formatMoney(match.price);
        }
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (addBtn) addBtn.disabled = !match.available;
        var buyBtn = form.querySelector('button[name="buy_now"]');
        if (buyBtn) buyBtn.disabled = !match.available;
      }
    } catch (e) {}
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: SHOP_CURRENCY });
  }

  /* ---------- Digital product page: isolated checkout ----------
     "Get it now" on a digital product must never let a digital item ride
     to checkout alongside physical items already in the cart. So instead of
     adding to whatever's currently in the cart, this clears the cart first,
     adds ONLY this digital item, then goes straight to checkout. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-digital-checkout]');
    if (!btn) return;
    var form = btn.closest('.product-form');
    if (!form) return;
    var idInput = form.querySelector('[data-selected-variant-id]');
    var id = idInput ? idInput.value : null;
    if (!id) return;

    btn.disabled = true;

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        window.location.href = CHECKOUT_URL;
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  /* ---------- Sticky add-to-cart bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('.product-form');
  if (stickyBar && mainForm) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.hidden = false;
        document.body.classList.toggle('has-sticky-atc-visible', visible);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    observer.observe(mainForm);

    var stickyBtn = stickyBar.querySelector('[data-sticky-add-to-cart]');
    var realAddBtn = mainForm.querySelector('[data-add-to-cart]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainForm.requestSubmit) { mainForm.requestSubmit(realAddBtn); } else { mainForm.submit(); }
      });
    }

    var stickyBuyNowBtn = stickyBar.querySelector('[data-sticky-buy-now]');
    var realBuyNowBtn = mainForm.querySelector('button[name="buy_now"]');
    if (stickyBuyNowBtn && realBuyNowBtn) {
      stickyBuyNowBtn.addEventListener('click', function () {
        if (mainForm.requestSubmit) { mainForm.requestSubmit(realBuyNowBtn); } else { mainForm.submit(); }
      });
    }
  }

  /* ---------- AJAX add to cart ----------
     Buy Now (name="buy_now") is intentionally left alone here -- no
     preventDefault, no custom handling. It submits as a completely normal,
     native HTML form submission, exactly like an unmodified Shopify theme,
     so any app (COD King, etc.) sees the standard, expected behavior. */
  document.querySelectorAll('.product-form, form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var isBuyNow = !!(e.submitter && e.submitter.name === 'buy_now');
      if (isBuyNow) {
        return; // let the browser submit this one natively
      }

      e.preventDefault();
      var formData = new FormData(form);
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          refreshCartUI(cart);
          var drawer = document.getElementById('CartDrawer');
          if (drawer && !drawer.hasAttribute('data-cart-drawer-disabled')) {
            drawer.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {})
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  function refreshCartUI(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    updateFreeShippingBar(cart);
    fetch(window.location.pathname + '?sections=cart-drawer').catch(function(){});
  }

  function updateFreeShippingBar(cart) {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    var fill = bar.querySelector('[data-free-shipping-fill]');
    var message = bar.querySelector('[data-free-shipping-message]');
    if (threshold <= 0) return;
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (message) {
      if (cart.total_price >= threshold) {
        message.textContent = "You've unlocked free shipping!";
      } else {
        var remaining = (threshold - cart.total_price) / 100;
        message.textContent = 'Add ' + remaining.toLocaleString(undefined, { style: 'currency', currency: SHOP_CURRENCY }) + ' more for free shipping';
      }
    }
  }
  (function initShippingBar() {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(updateFreeShippingBar).catch(function () {});
  })();

  /* ---------- Cart quantity change / remove (drawer + page) ----------
     Setting quantity to 0 removes the line item -- same end result as
     pressing the trash/remove button, just via the minus stepper or typing 0. */
  document.addEventListener('change', function (e) {
    var field = e.target.closest('[data-quantity-field]');
    if (!field) return;
    var item = field.closest('[data-cart-item]');
    if (!item) return;
    var line = item.getAttribute('data-line');
    var qty = parseInt(field.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (qty === 0) {
        item.remove();
      }
      refreshCartUI(cart);
    });
  });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    var item = removeBtn.closest('[data-cart-item]');
    if (!item) return;
    var line = item.getAttribute('data-line');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      item.remove();
      refreshCartUI(cart);
    });
  });

  /* ---------- Bonus: Wishlist ---------- */
  (function wishlist() {
    var KEY = 'denstore-wishlist';
    function getWishlist() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function setWishlist(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx > -1) { list.splice(idx, 1); } else { list.push(handle); }
      setWishlist(list);
      btn.classList.toggle('is-active', idx === -1);
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; });
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var list = getWishlist();
      if (list.indexOf(btn.getAttribute('data-handle')) > -1) btn.classList.add('is-active');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = getWishlist().length; });

    var wishlistGrid = document.querySelector('[data-wishlist-grid]');
    if (wishlistGrid) {
      var handles = getWishlist();
      var emptyMsg = wishlistGrid.querySelector('[data-wishlist-empty]');
      if (handles.length === 0) {
        if (emptyMsg) emptyMsg.hidden = false;
      } else {
        Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          products = products.filter(Boolean);
          if (products.length === 0) { if (emptyMsg) emptyMsg.hidden = false; return; }
          wishlistGrid.innerHTML = products.map(renderMiniCard).join('');
        });
      }
    }
  })();

  function renderMiniCard(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: SHOP_CURRENCY });
    return '<div class="product-card glass-card">' +
      '<a href="' + p.url + '" class="product-card__media product-card__media--square">' +
      (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" class="product-card__img product-card__img--primary">' : '') +
      '</a>' +
      '<button class="product-card__wishlist is-active" data-wishlist-toggle data-handle="' + p.handle + '" aria-label="Remove from wishlist">' +
      '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-10-9C.5 8 2 4 6 4c2 0 3.5 1 6 3.5C14.5 5 16 4 18 4c4 0 5.5 4 4 8-2.5 4.4-10 9-10 9z"/></svg></button>' +
      '<div class="product-card__info">' +
      '<a href="' + p.url + '" class="product-card__title">' + p.title + '</a>' +
      '<div class="product-card__price"><span class="price"><span class="price__regular">' + price + '</span></span></div>' +
      '</div></div>';
  }

  /* ---------- Bonus: Quick view modal ---------- */
  (function quickView() {
    var modal = document.getElementById('QuickViewModal');
    var body = modal ? modal.querySelector('[data-quick-view-body]') : null;
    if (!modal || !body) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view-open]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      body.innerHTML = '<div class="quick-view-modal__loading">Loading...</div>';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: SHOP_CURRENCY });
        var compareHtml = '';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          compareHtml = '<span class="price__compare">' + (p.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency: SHOP_CURRENCY }) + '</span>';
        }
        body.innerHTML =
          '<div class="quick-view-modal__media">' + (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '') + '</div>' +
          '<div class="quick-view-modal__info">' +
          '<h2>' + p.title + '</h2>' +
          '<div class="price">' + compareHtml + '<span class="price__regular">' + price + '</span></div>' +
          '<p class="quick-view-modal__desc">' + (p.description || '').replace(/<[^>]*>/g, '').slice(0, 180) + '&hellip;</p>' +
          '<form class="quick-view-modal__form">' +
          '<input type="hidden" name="id" value="' + p.variants[0].id + '">' +
          '<button type="submit" class="btn btn--primary btn--full btn--large" ' + (p.available ? '' : 'disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>' +
          '</form>' +
          '<a href="' + p.url + '" class="quick-view-modal__link">View full details &rarr;</a>' +
          '</div>';

        var form = body.querySelector('.quick-view-modal__form');
        if (form) {
          form.addEventListener('submit', function (ev) {
            ev.preventDefault();
            var fd = new FormData(form);
            fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
              .then(function () { return fetch('/cart.js'); }).then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
                modal.classList.remove('is-open');
                document.body.style.overflow = '';
                var drawer = document.getElementById('CartDrawer');
                if (drawer && !drawer.hasAttribute('data-cart-drawer-disabled')) {
                  drawer.classList.add('is-open');
                  document.body.style.overflow = 'hidden';
                }
              });
          });
        }
      }).catch(function () {
        body.innerHTML = '<p>Sorry, something went wrong loading this product.</p>';
      });
    });
  })();

  /* ---------- Bonus: Live predictive search ---------- */
  (function predictiveSearch() {
    var input = document.querySelector('[data-predictive-search-input]');
    var results = document.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) { results.innerHTML = '<p class="predictive-search-results__empty">No products found</p>'; results.hidden = false; return; }
            results.innerHTML = products.map(function (p) {
              return '<a href="' + p.url + '" class="predictive-search-results__item">' +
                (p.image ? '<img src="' + p.image + '" alt="">' : '') +
                '<div><strong>' + p.title + '</strong><span>' + p.price + '</span></div></a>';
            }).join('');
            results.hidden = false;
          }).catch(function () {});
      }, 250);
    });
  })();

  /* ---------- Bonus: Countdown timer ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) { el.closest('.countdown-banner').style.display = 'none'; return; }
    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) {
        var banner = el.closest('.countdown-banner');
        if (banner) banner.style.display = 'none';
        clearInterval(interval);
        return;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      el.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
      el.querySelector('[data-countdown-hours]').textContent = String(hours).padStart(2, '0');
      el.querySelector('[data-countdown-minutes]').textContent = String(minutes).padStart(2, '0');
      el.querySelector('[data-countdown-seconds]').textContent = String(seconds).padStart(2, '0');
    }
    tick();
    var interval = setInterval(tick, 1000);
  });

  /* ---------- Bonus: Back to top ---------- */
  var backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    backToTop.hidden = false;
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('is-visible', window.scrollY > 600);
    });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Bonus: Recently viewed products ---------- */
  (function recentlyViewed() {
    var KEY = 'denstore-recently-viewed';
    var productMeta = document.querySelector('meta[name="product-handle"]');
    var currentHandle = productMeta ? productMeta.content : null;

    var stored = [];
    try { stored = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}

    if (currentHandle) {
      stored = stored.filter(function (h) { return h !== currentHandle; });
      stored.unshift(currentHandle);
      stored = stored.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(stored)); } catch (e) {}
    }

    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var toShow = stored.filter(function (h) { return h !== currentHandle; }).slice(0, 4);
    if (toShow.length === 0) return;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    Promise.all(toShow.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) return;
      grid.innerHTML = products.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: SHOP_CURRENCY });
        return '<div class="product-card glass-card">' +
          '<a href="' + p.url + '" class="product-card__media product-card__media--square">' +
          (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g,'&quot;') + '" loading="lazy" class="product-card__img product-card__img--primary">' : '') +
          '</a>' +
          '<div class="product-card__info">' +
          '<a href="' + p.url + '" class="product-card__title">' + p.title + '</a>' +
          '<div class="product-card__price"><span class="price"><span class="price__regular">' + price + '</span></span></div>' +
          '</div></div>';
      }).join('');
      section.hidden = false;
    });
  })();
});
